import React from 'react'

import { ReactComponent as NewsAiIcon } from '../../assets/images/newsAiIcon.svg';
import { ReactComponent as Close } from '../../assets/images/close.svg';

import styles from './AIPopup.module.scss'

function AIpopup(props) {

    const data = props.data;


    return (
        <div className={styles.popupOverlay} onClick={() => props.setPopupStatus(false)}>
            <div className="container">
                <div
                    className={styles.popup}
                    onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
                >
                    <button className={styles.closeBtn} onClick={() => props.setPopupStatus(false)}>
                        <Close />
                    </button>
                    <div className={styles.owner}>
                        <NewsAiIcon />
                        <span>
                            Generated by Ai
                        </span>
                    </div>
                    <div className={styles.contents}>
                        <div className={styles.descriptionBlock}>
                            <h2>{props.newsTitle}</h2>
                            <p>
                                {data.summary}
                            </p>
                        </div>
                        <div className={styles.aiHighlights}>
                            <p>Key Highlights:</p>
                            <ul>
                                {
                                    data.highlights?.map((item, index) => {
                                        return (<li
                                            key={index}
                                            dangerouslySetInnerHTML={{ __html: item }}
                                        ></li>)

                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AIpopup